import React from 'react';
import {Col, Container, Row, Card, CardBody, Button, ButtonGroup} from 'reactstrap';
import {connect} from 'react-redux';
import LoadingProgress from '../../components/LoadingProgress'
import ReactQueryParams from 'react-query-params';
import {ButtonToolbar} from 'reactstrap';
import {fetchPrizeDataIfNeeded} from '../../redux/actions/PrizeActions';
import {fetchUtilsDataIfNeeded} from '../../redux/actions/UtilsActions'
import {withRouter} from 'react-router-dom';
import Alert from '../../components/Alert';
import * as TextManager from "../../modules/languages/TextManager";
import PrizeTable from './components/PrizeTable'
import ChooseDay from './components/ChooseDay';
import PrizeManagersTable from './components/PrizeManagersTable'

import WeekPicker from '../../components/WeekSelector'
import MultiSelectionFilterPrize from "./components/MultiSelectionFilterPrize";


export class Prize extends ReactQueryParams {
    constructor(props) {
        super(props);
        this.state = {
            searchValue: '',
            showTable: false,
            showConfigManagers: false,
            showConfigStore: false,
            configStep: 0,
            day: 0,
            manager: 0,
            managersFilter: []
        };
    }

    componentDidMount() {
        this.setState({
            managersFilter: this.queryParams['prize'] ? this.queryParams['prize'] : []
        });

        this.props.dispatch(fetchPrizeDataIfNeeded(this.queryParams));
        this.props.dispatch(fetchUtilsDataIfNeeded());
    }

    changeSearch = (e) => {
        this.setState({searchValue: e.target.value});
    };

    chooseDate = (day) => {
        //console.log("Here " + day)
        let dataTmp = this.props.data;

        if(dataTmp) {
            //console.log(dataTable);
            this.setState({showTable: true, day: day});

        }
    };

    back = () => {
        this.setState({showTable: false});
    };

    chooseManager = (id) => {
        this.setState({manager: id,
            showConfigStore: !this.state.showConfigStore,
            showConfigManagers: !this.state.showConfigManagers})
    };

    filterManagers = (e) => {
        //console.log(e)
        this.setState({managersFilter: e});
    };

    render() {

        let isAdmin = false;
        if (this.props.userData && this.props.userData.data && this.props.userData.data.userType) {
            isAdmin = this.props.userData.data.isAdmin;
        }

        let data = this.props.data;

        let day1 = {};
        let day2 = {};
        let day3 = {};
        let day4 = {};
        let day5 = {};

        if(data) {
            let tDay1 = data.find(a => a.day === 1);
            if(tDay1 !== undefined) day1 = tDay1;


            let tDay2 = data.find(a => a.day === 2);
            if(tDay2 !== undefined) day2 = tDay2;


            let tDay3 = data.find(a => a.day === 3);
            if(tDay3 !== undefined) day3 = tDay3;


            let tDay4 = data.find(a => a.day === 4);
            if(tDay4 !== undefined) day4 = tDay4;


            let tDay5 = data.find(a => a.day === 5);
            if(tDay5 !== undefined) day5 = tDay5;
        }

        let managerList = [];

        if(this.state.showTable) {
            let dataTable = this.props.data.find(a => a.day === this.state.day).dataArr;

            for(let indx in dataTable) {
                let tmp = managerList.find(e => e.value === dataTable[indx].managerId);
                if(tmp === undefined) {
                    managerList.push({value: dataTable[indx].managerId, label: dataTable[indx].managerName})
                }
            }
        }

        return (
            <Container className='dashboard'>

                {this.props.status === 'request' &&
                <Row>
                    <LoadingProgress/>
                </Row>
                }

                {this.props.status === 'error' &&
                <Row>
                    <Alert color='danger' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span></p>
                        <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                    </Alert>
                </Row>
                }

                {this.props.status === 'no_permission' &&
                <Row>
                    <Alert color='warning' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.loginFailed}</span>
                            {TextManager.getCurrentTextResource().Text.pleaseRefreshThePage}</p>
                    </Alert>
                </Row>
                }

                {this.props.status === 'success' &&
                <span>
                    <Row>
                      <Col md={12}>
                        <Card>
                            <CardBody style={{padding: "1.25rem"}}>
                                <h3 style={{textAlign: 'right'}}>{TextManager.getCurrentTextResource().Prize.title}</h3>
                                <div style={{display: 'flex', height: '100%', width: '80%'}}>
                                    <ButtonToolbar className='custom_dashboard_header_panel'>
                                        <WeekPicker endpoint='prize'/>
                                        {this.state.showTable && <MultiSelectionFilterPrize items={managerList} name='מנהלים' queryParam='prize'
                                                                                            onChange={(e) => this.filterManagers(e)}/>}
                                    </ButtonToolbar>
                                </div>
                            </CardBody>

                            <CardBody style={{padding: "1.25rem"}}>
                                <div style={{display: 'flex', height: '100%', justifyContent: 'flex-end'}}>
                                  <ButtonToolbar className='custom_dashboard_header_panel'>
                                      <form className='topbar__search material-form'>
                                          {this.state.showTable && <div
                                            className='search_field_form_control material-form__field topbar__search-field'>
                                            <div className='search_field_root search_field_custom-underline'
                                                 style={{border: 'groove'}}>
                                                <input className='search_field_custom-input' dir="rtl"
                                                       placeholder={TextManager.getCurrentTextResource().Text.searchByNameOrID}
                                                       value={this.state.searchValue}
                                                       onChange={(e) => this.changeSearch(e)}/>
                                            </div>
                                        </div>}
                                          {isAdmin && !this.state.showTable && <ButtonGroup className='btn-group--icons' style={{marginTop: "10px"}}>
                                            <Button outline color='primary'
                                                    onClick={() => this.setState({showConfigManagers: !this.state.showConfigManagers})}>להגדיר את החנות</Button>
                                        </ButtonGroup>}
                                      </form>
                                  </ButtonToolbar>
                                </div>
                            </CardBody>
                        </Card>
                        </Col>
                    </Row>

                    {/* START Old approach*/}
                    {/*this.state.showConfigManagers &&
                        <ChooseManager onClose={() => this.setState({showConfigStore: false, showConfigManagers: false})}
                                       chooseManager={this.chooseManager}/>
                    */}
                    {/*this.state.showConfigStore &&
                        <AddStores manager={this.state.manager}
                               onClose={() => this.setState({showConfigStore: !this.state.showConfigStore})}/>
                    */}
                    {/* END Old approach*/}

                    {/* START New approach*/}
                    {this.state.showConfigManagers &&
                        <PrizeManagersTable onClose={() => this.setState({showConfigManagers: false})}/>
                    }
                    {/* END New approach*/}

                    {!this.state.showTable &&  !this.state.showConfigManagers && <Row style={{flexDirection: 'row-reverse'}}>
                        <ChooseDay day={1} data={day1} chooseDate={this.chooseDate}/>
                        <ChooseDay day={2} data={day2} chooseDate={this.chooseDate}/>
                        <ChooseDay day={3} data={day3} chooseDate={this.chooseDate}/>
                        <ChooseDay day={4} data={day4} chooseDate={this.chooseDate}/>
                        <ChooseDay day={5} data={day5} chooseDate={this.chooseDate}/>
                    </Row>}

                    {this.state.showTable && <Row>
                         <PrizeTable day={this.state.day} back={this.back} searchValue={this.state.searchValue} managersFilter={this.state.managersFilter}/>
                    </Row>}
                </span>
                }

            </Container>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        status: state.prize.status,
        data: state.prize.data,
        userData: state.userData,
        utilsData: state.utilsData
    };
};

export default withRouter(connect(mapStateToProps)(Prize))